<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-06-01 08:57:21
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-09-26 15:18:52
-->
<template>
  <config-wrap>
  <div>

    <!-- 控制展示内容 是否支持搜索-->
      <div style="display: flex;align-items: center;justify-content: space-between;" class="mt15">
        <div class="w70 f13 f-grey">筛选项</div>
        <div style="flex:1;display: flex;">
          <div class="mode-select-item flex-center" :class="[item.value == mValue.isShowFilter ? 'mode-select-item-active' : '']"
               v-for="(item, index) in filterList"
               :key="index"
               @click="clickItem(item)">
            <span>{{ item.label }}</span>
          </div>
        </div>
    </div>


    <!--如果展示筛选项-->
    <div v-if="mValue.isShowFilter==0" style="clear:both;width:340px" class="mt15">

      <div style="display: flex;align-items: center;justify-content: space-between;">

        <div class="w80 f13 f-grey mr10">选择tab配置</div>

        <div style="flex:1;">
          <el-select  placeholder="请选择" size="small" v-model="mValue.tabOptionId" @change="changeTabSource($event)" >
            <el-option v-for="(item, index) in sourceList" :key="index" :value="item.tabOptionId" :label="item.name">
              {{item.name}}
            </el-option>
          </el-select>
        </div>

      </div>


      <div style="display: flex;align-items: center;justify-content: space-between;" class="mt15">

        <div class="w75 f13 f-grey mr16">展现形式</div>
        <div style="flex:1;">
          <el-radio v-model="mValue.showType" :label="item.value" v-for="(item, index) in preFormatList" :key="item.value">
            {{ item.label }}
          </el-radio>
        </div>
      </div>



      <!--如果有tab配置 暴漏出来筛选项-->
      <div v-show="mValue.tabOptionId" style="background:#f5f5f5;padding:10px 15px;border-radius:5px;margin-top:15px;margin-left:15px;">

        <div class="self-con mb10" v-for="(itemss,index) in mValue.filterData" :key="index">
          <div class="mt10 mr10 f13" style="color:#666;">{{itemss.name}}：</div>
          <div style="flex:1;margin-top:10px;">
                         <el-select  placeholder="请选择" size="small" multiple v-model="itemss.sign">
                        <el-option v-for="(itemsss, index) in control.curWidget[mValue.curDirectory].dataSource.paramsData"
                                   :key="index"
                                   :value="itemsss.source"
                                   :label="itemsss.sourceName">
                              {{itemsss.sourceName}}
                            </el-option>
                          </el-select>
          </div>
        </div>


      </div>




    </div>

  </div>
  </config-wrap>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import { mapGetters, mapMutations } from "vuex";
import {tabOptionPage} from "../../../api/easyApp";

export default {
  name: "SchemaFilter",
  mixins: [schemaMixin],
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: {}
    }
  },

  inject: ['mode',"control"],
  data() {
    return {
      filterList: [{
        "label": "显示",
        "value": '0',
      }, {
        "label": "不显示",
        "value": '1',
      }
      ],
      sourceList:[],
      preFormatList: [{
        "label": "顶部弹出",
        "value": 'topProup',
      }, {
        "label": "底部弹出",
        "value": 'bottomProup',
      }
      ]
    };
  },
  computed: {
    ...mapGetters(["project"]),
  },
  async created() {
   console.log("筛选项筛选项");
    let params={
      current:1,
      size:100,
      type:0
    }
    let resRes=await tabOptionPage(params);
    let records=resRes.data.records;
    for(var i in records){
      records[i].jsontext=JSON.parse(records[i].jsontext);
    }
    this.sourceList=records;
    console.log("==this.sourceList==:",this.sourceList);

  },
  methods: {
    clickItem(item){
      this.mValue.isShowFilter=item.value;
    },
    changeTabSource(e){
      const index1 = this.sourceList.findIndex(item => item.tabOptionId == e);
      if(index1!=-1){
        this.mValue.filterData=this.sourceList[index1].jsontext;
        console.log("this.mValue.filterData",this.mValue.filterData);
      }
    }
  }
};
</script>

<style lang="scss" scoped>


.self {
  padding: 15px;
  border: 1px solid #ededed;
  border-radius: 5px;
}

.self-con {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #969799;
}


.wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 25px;

  .wrap-label {
    font-size: 14px;
    line-height: 32px;
  }

  .wrap-body{
    padding:0px;
  }

}
@import "../../../scss/variable";

.mode-select-item {
  padding: 8px 10px;
  min-width: 55px;
  border: 1px solid #dcdee0;
  /*no*/
  border-radius: 0;
  font-size: 12px;
  /*no*/
  font-weight: 500;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: $color-theme;
    border-color: $color-theme;
    background-color: #e0edff;

    i {
      color: $color-theme;
    }
  }

  i {
    color: #979797;
  }
}

.mode-select-item-active {
  color: $color-theme;
  border-color: $color-theme;
  background-color: #e0edff;

  i {
    color: $color-theme;
  }
}
</style>